import React from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import LeadForm from "@/components/LeadForm";
import { School, Building2, Dumbbell, Briefcase, HeartHandshake, Wrench, Tv, Radio, Landmark, CalendarClock, GraduationCap } from "lucide-react";

const PARTNERS = [
  { Icon: School,         title: "Schools" },
  { Icon: GraduationCap,  title: "Colleges" },
  { Icon: Dumbbell,       title: "Sports Academies" },
  { Icon: Building2,      title: "Real Estate Developers" },
  { Icon: HeartHandshake, title: "Corporate CSR" },
  { Icon: Briefcase,      title: "Fitness Brands" },
  { Icon: Wrench,         title: "Equipment Companies" },
  { Icon: Tv,             title: "Broadcasters" },
  { Icon: Radio,          title: "OTT Platforms" },
  { Icon: Landmark,       title: "State Associations" },
  { Icon: CalendarClock,  title: "Event Companies" },
];

export default function Partnerships() {
  return (
    <div>
      <PageMeta
        title="Partner With PSHL8"
        description="Long-term PSHL8 partnerships across education, real estate, fitness, equipment, media and government bodies."
        image="/api/og/partnerships/og-image.png"
      />
      <PageHero
        overline="Collaborate With PSHL"
        title={<>Partner With <span className="text-pshl-electric">PSHL8.</span></>}
        subtitle="A long-term partnership network across education, real estate, fitness, equipment, media, and government bodies."
        bgImage="https://images.pexels.com/photos/6468601/pexels-photo-6468601.jpeg"
      />

      <section className="section pt-0">
        <div className="pshl-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {PARTNERS.map(({ Icon, title }, i) => (
            <div key={title} data-testid={`partner-${i}`} className="bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors p-5">
              <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40">
                <Icon className="h-5 w-5 text-pshl-electric" />
              </div>
              <div className="font-display text-lg text-white mt-3">{title}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-[#08090E]">
        <div className="pshl-container grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.32em] text-pshl-electric font-display mb-3">Collaborate</div>
            <h2 className="font-display text-4xl text-white tracking-tighter">Let’s Build Something <span className="text-gold-metallic">Together.</span></h2>
            <p className="mt-4 text-white/75 leading-relaxed">Share your organization profile and the type of collaboration you’re considering. Our team will revert in 24 hours.</p>
          </div>
          <div className="lg:col-span-7"><LeadForm defaultInterest="general" title="Partnership Inquiry" /></div>
        </div>
      </section>
    </div>
  );
}
